import axios from "@/libs/api.request";
// 获取应收报表列表
export const getLocation = params => {
  return axios.request({
    url: "/report/stock/location",
    method: "get",
    params
  });
};

export const getSku = params => {
  return axios.request({
    url: "/report/stock/sku",
    method: "get",
    params
  });
};

// 生成账单
export const createBill = params => {
  return axios.request({
    url: "/report/stock/createBill",
    method: "get",
    params
  });
};

export const uploadFixedStock = data => {
  return axios.request({
    url: "/report/stock/uploadFixedStock",
    method: "post",
    data
  });
};

